import request from '@/utils/request'

export function getBlogSortList(params) {
  return request({
    url: process.env.WEB_API + '/classify/getSortList',
    method: 'get',
    params
  })
}

export function getArticleByBlogSortUid(params) {
  return request({
    url: process.env.WEB_API + '/classify/getArticleBySortUid',
    method: 'get',
    params
  })
}


// WEBPACK FOOTER //
// ./src/api/classify.js